import type { AuthSDKConfig } from '@fhl-world/auth-core/webpack-esm';

export const AUTH_CONFIG: AuthSDKConfig = {
	CLIENT_ID: process.env.REACT_APP_CLIENT_ID as string,

	REFRESH_LOADING_TIMEOUT_MS: process.env.REACT_APP_REFRESH_LOADING_TIMEOUT
		? Number(process.env.REACT_APP_REFRESH_LOADING_TIMEOUT)
		: 7 * 1000, // 7 sec
	REFRESH_BEFORE_MS: process.env.REACT_APP_REFRESH_BEFORE
		? Number(process.env.REACT_APP_REFRESH_BEFORE)
		: 60 * 1000, // 60 sec
	ACTIVITY_TIMEOUT_MS: process.env.REACT_APP_ACTIVITY_TIMEOUT
		? Number(process.env.REACT_APP_ACTIVITY_TIMEOUT)
		: 5 * 60 * 1000, // 5 min

	ACTIVITY_EVENTS: [
		'mousemove',
		'keydown',
		'mousedown',
		'touchstart',
		'visibilitychange',
	],

	IS_LOADING_KEY: 'slmn_auth_isLoading',
	TOKEN_PAYLOAD_KEY: 'slmn_auth_tokenPayload',
	USER_ACTIVITY_KEY: 'slmn_auth_activity',
	INACTIVE_NOTIFIED_KEY: 'slmn_auth_isInactiveNotified',
	AUTH_STATE_KEY: 'slmn_auth_state',
	CODE_VERIFIER_KEY: 'slmn_auth_code_verifier',

	AUTH_PAGE_URL: process.env.REACT_APP_AUTH_PAGE_URL as string,
	EXCHANGE_CODE_URL: process.env.REACT_APP_EXCHANGE_CODE_URL as string,
	REFRESH_TOKEN_URL: process.env.REACT_APP_REFRESH_TOKEN_URL as string,
	USERINFO_URL: process.env.REACT_APP_USERINFO_URL as string,
	LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL as string,

	APP_URL: process.env.REACT_APP_APP_URL as string,

	onUserInactive: () => {},
	onUserActive: () => {},
};
